
























import { computed, defineComponent, ref, toRef, watch } from "@vue/composition-api";
import { TaxFormType } from "@scrile/api-provider/dist/api/PayeeInformationProvider";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import { FormField, FormValues } from "@/types";
import BaseForm from "@/components/BaseForm";
import BaseInputRadio from "@/components/BaseInputRadio";

export default defineComponent({
  name: "ResidenceForm",
  components: { BaseInputRadio, BaseForm },
  props: {
    userId: { type: String, required: true },
    active: { type: Boolean, required: true },
  },
  setup(props, { emit }) {
    const valid = ref(false);
    const values = ref<FormValues>({
      citizen: null,
      resident: null,
    });

    const taxFormType = computed(() =>
      !values.value.citizen && !values.value.resident ? TaxFormType.W8 : TaxFormType.W9
    );

    const formFields: FormField[] = [
      {
        name: "citizen",
        type: "radio",
        label: $t("Are you US citizen?"),
        options: [
          { text: $t("Yes"), value: true },
          { text: $t("No"), value: false },
        ],
      },
      {
        name: "resident",
        type: "radio",
        label: $t("Are you US resident?"),
        options: [
          { text: $t("Yes"), value: true },
          { text: $t("No"), value: false },
        ],
      },
    ];

    const checkValid = () => {
      valid.value = Object.values(values.value).every(value => value !== null);
      emit("setValid", valid.value);
    };
    const onRadioInput = (value: boolean, key: string) => {
      values.value[key] = value;
      checkValid();
      if (valid.value) {
        emit("setTaxForm", taxFormType.value);
      }
    };

    const submitTaxInfo = async () => {
      await providers.PayeeInformationProvider.update({
        data: { userId: props.userId, taxFormType: taxFormType.value },
      });
    };

    const created = () => {
      emit("setCb", () => submitTaxInfo());
    };

    created();

    watch(toRef(props, "active"), newVal => {
      if (newVal) {
        checkValid();
      } else {
        emit("setValid", true);
      }
    });

    return { formFields, values, onRadioInput };
  },
});
